<div class="form-group content">
	<label class="titleControl">{{ labelTitle }}</label>
	<div class="row">
		<div class="input-group col">
			<input
				class="form-control calendar_"
				placeholder="yyyy-mm-dd"
				name="dp"
				ngbDatepicker
				#d="ngbDatepicker"
				[(ngModel)]="date_setting"
				(dateSelect)="onDateSelection($event)"
				[disabled]="inactive"
			/>
			<button
				class="btn btn-outline-secondary calendar cal-time"
				(click)="d.toggle()"
				type="button"
			></button>
		</div>
		<div class="input-group col align-time">
			<ngb-timepicker
				[(ngModel)]="time"
				[meridian]="meridian"
				(click)="onTimeSelect($event)"
				[disabled]="inactive"
				class="formatHour"
			></ngb-timepicker>
		</div>
	</div>
</div>

<!-- this control could be seted on this way from father form-->
<!-- <app-form-datetime labelTitle="Select start datetime" [hourPredeter]="16" [minutePredeter]="40" [dateCurrent]=true [disabled]="false"></app-form-datetime> -->
